import { InboxNotiDto } from '@diritto/common/notification/dtos/inbox-noti.dto';
import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import { convertToDotString, convertToRelativeString } from '@diritto/common/utils/date';
import styled from '@emotion/styled';
import * as Styled from 'app-components/inbox/items/styles';
import { DirittoCircleIcon } from 'icons/DirittoCircleIcon';
import Link from 'next/link';
import React, { useState } from 'react';
import { Divider } from 'ui-components/common/Divider';
import { ExternalLink } from 'ui-components/common/ExternalLink';

interface DirittoMessageInboxNotiItemProps {
  inboxNoti: InboxNotiDto;
  link: string;
  externalLink: string;
}

const InternalDirittoMessageInboxNotiItem = ({ inboxNoti }: { inboxNoti: InboxNotiDto }) => {
  const [isRead] = useState(inboxNoti.isRead);

  return (
    <Styled.Container>
      <Styled.LeftIconSection>
        <Styled.Unread isRead={isRead} />
        <DirittoCircleIcon className="size-[56px]" />
      </Styled.LeftIconSection>
      <Styled.RightSection>
        <Styled.TitleWrapper>
          <Styled.SanitizeHTMLTitle
            html={`${inboxNoti.title}<span class="inbox-title-date" title="${convertToDotString(
              inboxNoti.sentAt,
            )}">${convertToRelativeString(inboxNoti.sentAt)}</span>`}
            options={{
              allowedTags: ['b', 'span', 'br'],
              allowedClasses: {
                span: ['inbox-title-date'],
              },
              allowedAttributes: { span: ['title'] },
            }}
          />
        </Styled.TitleWrapper>
        {inboxNoti.description?.trim() && (
          <Styled.Extra>
            <StyledDesc>{inboxNoti.description}</StyledDesc>
          </Styled.Extra>
        )}
      </Styled.RightSection>
      <Divider color={Color.Gray200} />
    </Styled.Container>
  );
};

export const DirittoMessageInboxNotiItem = ({ inboxNoti, link, externalLink }: DirittoMessageInboxNotiItemProps) => {
  if (link.trim()) {
    return (
      <Link href={link.trim()}>
        <InternalDirittoMessageInboxNotiItem inboxNoti={inboxNoti} />
      </Link>
    );
  }

  if (externalLink.trim()) {
    return (
      <ExternalLink href={externalLink.trim()}>
        <InternalDirittoMessageInboxNotiItem inboxNoti={inboxNoti} />
      </ExternalLink>
    );
  }

  return <InternalDirittoMessageInboxNotiItem inboxNoti={inboxNoti} />;
};

const StyledDesc = styled.p`
  ${Typography.XXSmall}
  color: ${Color.Gray600};
  text-align: left;
`;
